export default "__VITE_ASSET__CJzeGguK__"